export const MIN_ACCOUNT_PASSWORD_LENGTH = 8;
export function assessPasswordStrength(password) {
    const requirements = [
        {
            id: 'length',
            label: `At least ${MIN_ACCOUNT_PASSWORD_LENGTH} characters`,
            met: password.length >= MIN_ACCOUNT_PASSWORD_LENGTH,
        },
        { id: 'uppercase', label: 'Uppercase letter', met: /[A-Z]/.test(password) },
        { id: 'lowercase', label: 'Lowercase letter', met: /[a-z]/.test(password) },
        { id: 'number', label: 'Number', met: /\d/.test(password) },
    ];
    const score = requirements.filter((requirement) => requirement.met).length;
    return {
        requirements,
        score,
        valid: score === requirements.length,
        label: score >= 4 ? 'Strong' : score >= 2 ? 'Fair' : 'Weak',
    };
}
//# sourceMappingURL=passwordStrength.js.map